<template>
  <pt-promotion-coupon class="pt-promotion-coupon__withData" @deleteCoupon="deleteCoupon" ref="table" @couponStatus="couponStatus" @promotionDelete="promotionDelete"
  @promotionStatus="promotionStatus"></pt-promotion-coupon>
</template>

<script>
import PtPromotionCoupon from './index'
export default {
  name: 'pt-promotion-coupon__withData',
  components: {
    'pt-promotion-coupon': PtPromotionCoupon
  },
  methods: {
    promotionDelete (id) {
      this.$store.dispatch('promotionDelete', id).then(res => {
        this.$message.success('删除促销活动成功')
        this.$refs.table.promotionsList()
      }).catch(err => {
        this.$message.error(err || '删除促销活动失败')
      })
    },
    promotionStatus (id, status) {
      let data = {
        id: id,
        status: status
      }
      this.$store.dispatch('promotionStatus', data).then(res => {
        this.$message.success('结束促销活动成功')
        this.$refs.table.promotionsList(0)
      }).catch(err => {
        this.$message.error(err || '结束促销活动失败')
      })
    },
    couponStatus (id, status) {
      let data = {
        status: status,
        id: id
      }
      this.$store.dispatch('couponUpdateStatus', data).then(res => {
        this.$message.success((status === 'DISABLED' ? '结束优惠劵' : '提交审核') + '成功')
        this.$refs.table.couponList(0)
      }).catch(err => {
        this.$message.error(err || (status === 'DISABLED' ? '结束优惠劵' : '提交审核') + '失败')
      })
    },
    deleteCoupon (id) {
      this.$store.dispatch('coupontDelete', id).then(res => {
        this.$message.success('删除优惠劵成功')
        this.$refs.table.couponList(0)
      }).catch(err => {
        this.$message.error(err || '删除优惠劵失败')
      })
    }
  }
}
</script>
